import React, { useState } from "react";
import StaffBio from "../../../../modals/StaffBio";

interface StaffMember {
  name: string;
  role: string;
  image: string;
  alt: string;
}

interface Props {
  member: StaffMember;
}

const StaffMemberCard: React.FC<Props> = ({ member }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div
        className="group bg-white/[0.03] border border-white/10 rounded-lg p-6 text-center cursor-pointer transition-all duration-200 hover:bg-white/[0.06] hover:border-white/20 flex flex-col items-center"
        onClick={() => setIsModalOpen(true)}
      >
        <img
          src={member.image}
          alt={member.alt}
          className="w-20 h-20 rounded-full object-cover object-top mb-4 opacity-90 group-hover:opacity-100 transition-opacity duration-200"
        />
        <p className="text-sm font-semibold text-white group-hover:text-[#00A3FF] transition-colors duration-200">
          {member.name}
        </p>
        <p className="text-xs text-white/40 mt-1">{member.role}</p>
      </div>

      <StaffBio
        member={member}
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
      />
    </>
  );
};

export default StaffMemberCard;
